import {ItemContainer} from "../return/ItemContainer";

export class FinalLensRequest {
  item: ItemContainer;

  constructor(item: ItemContainer) {
    this.item = item;
  }
}
